import { Controller } from "@hotwired/stimulus"

// Adds public-navbar--stuck once the page has scrolled and the sticky navbar
// overlays content.
export default class extends Controller {
  connect() {
    this.update = () => {
      this.element.classList.toggle("public-navbar--stuck", window.scrollY > 0)
    }
    window.addEventListener("scroll", this.update, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.update)
  }
}
